/**
 * The 4-Year-Old Attestation state for an Opportunity Scholarship student.
 * String values match the API C# enum member names, since the API serializes enums as
 * strings (JsonStringEnumConverter) — keeping the dropdown value in sync with the wire format.
 */
export enum FourYearOldAttestationStatus {
  NotRequired = 'NotRequired',
  Required = 'Required',
  Completed = 'Completed'
}
